import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { TableCell, TableRow, Tooltip } from '@mui/material';

import OnEditIcon from '../../../../icons/OnEditIcon';

import table from '../../../../commonStyles/tables.module.css';

const DocmanTriggerRow = ({ row, onEdit, isEditDisabled }) => {
    // LOCAL STATE
    const [toolTipContent, setToolTipContent] = useState('');

    // USE EFFECTS
    useEffect(() => {
        if (row.statusReasons.length > 1)
            setToolTipContent(row.statusReasons.map((el, i) => <div key={`${el}-${i}`}>{el}</div>));
        else setToolTipContent('');
    }, [row.statusReasons]);

    return (
        <TableRow hover className={table.basicRowStripes}>
            <TableCell>{row.snomedCode}</TableCell>
            <TableCell>{row.status || '-'}</TableCell>
            <TableCell>
                {!toolTipContent.length ? (
                    row.statusReasons[0] || '-'
                ) : (
                    <span>
                        <Tooltip title={toolTipContent} placement="top">
                            <span>{row.statusReasons[0]}...</span>
                        </Tooltip>
                    </span>
                )}
            </TableCell>
            <TableCell>{row.emailTemplate}</TableCell>
            <TableCell>{row.active ? 'Y' : 'N'}</TableCell>
            <TableCell>{row.snomedId}</TableCell>
            <TableCell align="right">
                <OnEditIcon onEdit={(e) => onEdit(e, row)} active={!isEditDisabled} />
            </TableCell>
        </TableRow>
    );
};

DocmanTriggerRow.propTypes = {
    row: PropTypes.object,
    onEdit: PropTypes.func,
    isEditDisabled: PropTypes.bool
};

export default DocmanTriggerRow;
